// @flow
import React, { Component, Fragment } from "react";
import List from "@material-ui/core/List";
import ListSubheader from "@material-ui/core/ListSubheader";
import Divider from "@material-ui/core/Divider";

type AppbarMenuGroupPropType = {
  subHeader: string,
  subLists: React$Element<*>
};

class AppbarMenuGroup extends Component<*, AppbarMenuGroupPropType> {
  render(): React$Element<*> {
    return (
      <Fragment>
        <List
          disablePadding
          subheader={
            <ListSubheader component="div">
              {this.props.subHeader}
            </ListSubheader>
          }
        >
          {this.props.subLists}
        </List>
        <Divider />
      </Fragment>
    );
  }
}

export default AppbarMenuGroup;
